module.exports = __webpack_public_path__ + "img/spotifyplaylist-placeholder.58343a64.jpg";